import "./WTPTooltip.scss";

const WTPTooltip = (content: any) => {
  if (
    content &&
    content.active &&
    content.payload &&
    content.payload.length > 0
  ) {
    return (
      <div className="wtp-custom-tooltip">
        <p className="label">{`${content.payload[0].name} : ${content.payload[0].value}t`}</p>
      </div>
    );
  }
  return null;
};

export default WTPTooltip;
